export enum PolicyStatus {
  ACTIVE = 'P',
  CANCELLED = 'C',
  QUOTE = 'Q',
}

export const POLICY_PAGE_SIZE = 4;
export const MAX_GROUPED_POLICIES_PAGE_SIZE = 99;
